import './style.css';

export const TotalMoney = ({someValueTransactions}) => {

    //FUNÇÃO DE REDUCE COM MAIS DE UMA LINHA
    function reducer(previous, current) {

        current.type === 'Entrada' ? (

            previous = previous + current.value 

        ) : (

            previous = previous - current.value 

        )

        return previous;

    }

    return (

        <div className="total">

            <div className="total-text">
                <h2>Valor total:</h2>
                <p>O valor se refere ao saldo</p>
            </div>

            <h3 className="total-value">R$
                {
                    someValueTransactions.reduce(reducer, 0)
                }
            </h3>

                    
        </div>

    );

}

